// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__raaoZ","btn":"style_btn__a8ZvS","back_button":"style_back_button__RI23f"};